<template>
  <div class="container container-fluid card my-4">

    <div v-if="mostrarForm">
      <div class="text-left pt-4 mx-2">
        <h5>USUARIOS</h5>
      </div>

    </div>

    <!--  SPINERS CARGA TABLA -->
    <div v-if="loadingComponent" class="spinner-container container-fluid">
      <Loading-Style/>
    </div>

    <transition name="slide-fade">
      <div v-if="!loadingComponent" class="container">
        <div v-if="mostrarTabla" id="content">
          <TableComponent 
          :dataDATA="responseDATA" 
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from "vue";
import apiUsers from "../../../apis/User";
import { useRouter } from "vue-router";
import TableComponent from "./TableUsuario";
import { handleSweetInfo } from "../../../Utils/StatusHandler";

export default {
  name: "UsuarioListIndex",
  components: {
    TableComponent,
  },
  setup() {
    const loadingComponent = ref(false);
    const mostrarForm = ref(true);
    const response = ref(null);
    const mostrarTabla = ref(true);
    const responseDATA = ref(null);

    const errors = ref([]);
    const alert = ref([]);

    const handleSweetAlert = (info) => {
      handleSweetInfo(info, { alert });
    };

    const fetchUsers = async () => {
      try { 
        const response = await apiUsers.getIndex();

        if (response) {
          const resultadosDATA = response.data;

          if (resultadosDATA.length > 0) {

            responseDATA.value = resultadosDATA;

            return resultadosDATA;
          } else if (resultadosDATA.length === 0) {
            handleSweetAlert(response);
          } else {
            handleSweetAlert(response);
          }
        }
      } catch (error) {
        console.error(error);
        handleSweetAlert(error);
      } finally {
        loadingComponent.value = false;
      }
    };

    const formsList = () => {

      loadingComponent.value = true;

      fetchUsers().then((forms) => {
        if (forms) {
          response.value = forms;
          loadingComponent.value = false;
        }
      });
    };

    onMounted( () => {
      formsList();
    });

    return {
      loadingComponent,
      mostrarForm,
      response,
      mostrarTabla,
      responseDATA,
      errors,
      alert,
    };
  },
};
</script>